<template>
    <div>
        <el-dialog
            title="信息"
            :visible.sync="orderId.state"
            width="70%"
            @close="dialogVisibleClone"
            append-to-body
            class="dialog_container"
        >
            <hr style="margin-bottom: 20px" color="#CCCCCC" />

            <div class="name-per">
                <div
                    v-for="(item, index) in titleList"
                    :key="index"
                    class="name-list"
                    @click="changeIdx(item.id)"
                >
                    <div>
                        <div
                            class="name-title"
                            :class="{
                                changeColor: controlAddContent == item.id,
                            }"
                        >
                            <div></div>
                            <div><i class="el-icon-circle-check"></i></div>
                            <div></div>
                        </div>
                        <div class="name-bottom">{{ item.name }}</div>
                    </div>
                </div>
            </div>

            <!-- 基本信息 -->
            <el-form
                v-show="controlAddContent == 1"
                ref="formRef"
                :model="formData"
                label-width="105px"
            >
                <div class="serviceInfoBox">
                    <div>
                        <el-form-item
                            label="姓名:"
                            required
                            prop="customerName"
                        >
                            <el-input
                                v-model="formData.customerName"
                                placeholder="请输入"
                                disabled
                                style="width: 475px"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="性别:" prop="gender">
                            <el-select
                                v-model="formData.gender"
                                disabled
                                placeholder="请选择"
                                style="width: 475px"
                            >
                                <el-option label="男" value="0"></el-option>
                                <el-option label="女" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="联系方式:" required prop="phone">
                            <el-input
                                v-model="formData.phone"
                                placeholder="请输入"
                                disabled
                                style="width: 475px"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="邻居联系人1:"
                            required
                            prop="phone"
                        >
                            <el-input
                                v-model="formData.phone"
                                placeholder="请输入"
                                disabled
                                style="width: 475px"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="邻居联系人2:"
                            required
                            prop="phone"
                        >
                            <el-input
                                v-model="formData.phone"
                                placeholder="请输入"
                                disabled
                                style="width: 475px"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号:" required prop="idCard">
                            <el-input
                                v-model="formData.idCard"
                                disabled
                                placeholder="请输入"
                                style="width: 475px"
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="年龄:">
                            <el-input
                                style="width: 475px"
                                disabled
                                v-model="formData.age"
                            ></el-input>
                        </el-form-item>

                        <el-form-item
                            label="老人类别:"
                            required
                            prop="elderlyBelongCategory"
                        >
                            <el-select
                                v-model="formData.elderlyBelongCategory"
                                disabled
                                placeholder="请选择"
                                style="width: 475px"
                            >
                                <el-option
                                    v-for="(item, index) in serviceTypeList"
                                    :key="index"
                                    :label="item.dictLabel"
                                    :value="item.dictCode"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="rightBox">
                        <el-form-item prop="photo" style="margin-left=0px;">
                            <el-upload
                                class="avatar-uploader"
                                :action="baseUrl"
                                disabled
                                :show-file-list="false"
                            >
                                <img
                                    v-if="formData.photo"
                                    :src="formData.photo"
                                    class="avatar"
                                />
                                <i
                                    v-else
                                    class="el-icon-plus avatar-uploader-icon"
                                ></i>
                            </el-upload>
                            <div class="uploadBtn">上传图片</div>
                        </el-form-item>
                        <div class="bgs">
                            <div class="bgColor">
                                <div class="days">Days</div>
                                <div class="data">{{ guardDays }}</div>
                            </div>
                            <div class="uploadBtn">守护天数</div>
                        </div>
                    </div>
                </div>
                <el-form-item label="居住地址:" required>
                    <div class="addressContent">
                        <div class="addressBox">
                            <div class="addressItem">
                                <el-form-item prop="provinceId">
                                    <el-select
                                        v-model="formData.provinceId"
                                        placeholder="请选择省"
                                        disabled
                                        ref="selectShengChange"
                                    >
                                        <el-option
                                            v-for="(
                                                item, index
                                            ) in provinceList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="addressItem">
                                <el-form-item prop="cityId">
                                    <el-select
                                        v-model="formData.cityId"
                                        disabled
                                        placeholder="请选择市"
                                        ref="selectShiChange"
                                    >
                                        <el-option
                                            v-for="(item, index) in cityList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="addressItem">
                                <el-form-item prop="areaId">
                                    <el-select
                                        v-model="formData.areaId"
                                        disabled
                                        placeholder="请选择区"
                                        ref="selectQuChange"
                                    >
                                        <el-option
                                            v-for="(item, index) in areaList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="addressItem">
                                <el-form-item prop="streetId">
                                    <el-select
                                        v-model="formData.streetId"
                                        disabled
                                        placeholder="请选择街道"
                                        ref="selectJiedaoChange"
                                    >
                                        <el-option
                                            v-for="(item, index) in streetList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode + index"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="addressItem">
                                <el-form-item prop="communityId">
                                    <el-select
                                        v-model="formData.communityId"
                                        disabled
                                        placeholder="请选择社区"
                                        ref="selectShequChange"
                                    >
                                        <el-option
                                            v-for="item in communityList"
                                            :key="item.id"
                                            :label="item.address"
                                            :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <el-form-item prop="place" style="margin: 5px 0">
                            <input
                                v-model.trim="formData.address"
                                id="tipinput"
                                disabled
                                class="el-input__inner"
                                @focus="getMap('tipinput')"
                                placeholder="请输入关键字"
                                autocomplete="off"
                            />
                        </el-form-item>
                        <div class="map_container">
                            <div
                                id="container1"
                                style="width: 100%; height: 200px"
                            ></div>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <el-form
                v-show="controlAddContent == 2"
                ref="formReff"
                :model="formData"
                label-width="150px"
            >
                <el-form-item label="自理情况：" required>
                    <el-radio label="0" v-model="formData.selfCare" disabled
                        >较差，完全需要别人照顾
                    </el-radio>
                    <el-radio label="1" v-model="formData.selfCare" disabled
                        >一般，有些事情需要别人照顾
                    </el-radio>
                    <el-radio label="2" v-model="formData.selfCare" disabled
                        >较好，一般不需要别人照顾
                    </el-radio>
                    <el-radio label="3" v-model="formData.selfCare" disabled
                        >很好，还可以照顾别人
                    </el-radio>
                </el-form-item>
                <el-form-item label="健康状况：" required>
                    <el-checkbox-group v-model="healthCondition" disabled>
                        <el-checkbox label="0">身体健康</el-checkbox>
                        <el-checkbox label="1">高血压</el-checkbox>
                        <el-checkbox label="2">冠心病</el-checkbox>
                        <el-checkbox label="3">脑卒中</el-checkbox>
                        <el-checkbox label="4">糖尿病</el-checkbox>
                        <el-checkbox label="5">类风湿</el-checkbox>
                        <el-checkbox label="6">脑出血</el-checkbox>
                        <el-checkbox label="7">高血脂</el-checkbox>
                        <el-checkbox label="8">系统性班狼疮</el-checkbox>
                        <el-checkbox label="9">恶性肿瘤</el-checkbox>
                        <el-checkbox label="10">重性精神病</el-checkbox>
                        <el-checkbox label="11">结核病</el-checkbox>
                        <el-checkbox label="12">肝炎</el-checkbox>
                        <el-checkbox label="13">其他法定传染病</el-checkbox>
                        <el-checkbox label="14">其他</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <el-table
                :data="gongdanData"
                border
                style="width: 100%"
                v-show="controlAddContent == 3"
            >
                <el-table-column
                    type="index"
                    label="序号"
                    width="100"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="orderNo"
                    label="工单编号"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="serviceName"
                    label="服务名称"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="startDateTime"
                    label="服务开始时间"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="endDateTime"
                    label="服务结束时间"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="servePrice"
                    label="服务时长"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="personName"
                    label="服务人员"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="serviceContent"
                    label="服务内容"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    width="100"
                    label="工单状态"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span
                            v-if="
                                scope.row.status === '0' ||
                                scope.row.status == null
                            "
                            >未开始</span
                        >
                        <span v-else-if="scope.row.status === '1'">进行中</span>
                        <span v-else-if="scope.row.status === '2'">已结束</span>
                        <span v-else-if="scope.row.status === '3'">已完成</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-link
                            :underline="false"
                            @click="checkGongdaninfo(scope.row, '查看工单列表')"
                            >查看
                        </el-link>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top: 10px">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 40, 100]"
                    :page-size="gongdanQuery.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="gongdanTotal"
                >
                </el-pagination>
            </div>
        </el-dialog>
        <!-- 查看弹框 -->
        <el-dialog
            title="查看"
            :visible.sync="checkDialogVisible"
            width="70%"
            @close="clearForm()"
        >
            <hr style="margin-bottom: 20px" />
            <!-- 工单信息 -->
            <el-form
                ref="form"
                :model="gongdanInfoForm"
                label-width="150px"
                disabled
            >
                <el-form-item label="工单编号：">
                    <el-input v-model="gongdanInfoForm.orderNo"></el-input>
                </el-form-item>
                <el-form-item label="服务名称：">
                    <el-input v-model="gongdanInfoForm.serviceName"></el-input>
                </el-form-item>
                <el-form-item label="服务开始时间：">
                    <el-input
                        v-model="gongdanInfoForm.startDateTime"
                    ></el-input>
                </el-form-item>
                <el-form-item label="服务结束时间：">
                    <el-input v-model="gongdanInfoForm.endDateTime"></el-input>
                </el-form-item>
                <el-form-item label="服务时长：">
                    <el-input v-model="gongdanInfoForm.servePrice"></el-input>
                </el-form-item>
                <el-form-item label="服务人员：">
                    <el-input v-model="gongdanInfoForm.personName"></el-input>
                </el-form-item>
                <el-form-item label="服务内容：">
                    <el-input
                        type="textarea"
                        v-model="gongdanInfoForm.serviceContent"
                    ></el-input>
                </el-form-item>
                <el-form-item label="图片：">
                    <div class="demo-image__preview">
                        <el-image
                            v-for="(item, index) in gongdanInfoForm.serPhoto"
                            :src="item"
                            :key="index"
                            :preview-src-list="
                                srcList(index, gongdanInfoForm.serPhoto)
                            "
                        >
                            <div slot="error" class="image-slot">
                                <i
                                    class="el-icon-plus avatar-uploader-icon"
                                ></i>
                            </div>
                        </el-image>
                    </div>
                </el-form-item>
                <el-form-item label="视频：">
                    <video
                        :src="gongdanInfoForm.video"
                        style="height: 100px; width: 200px"
                        autoplay="true"
                        controls
                        muted
                    ></video>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
export default {
    props: ["orderId"],

    data() {
        return {
            query: {
                pageNo: 1,
                pageSize: 10,
            },
            gongdanQuery: {
                pageNo: 1,
                pageSize: 10,
            },
            gongdanTotal: 0,
            serviceDuration: "",
            dialogVisible: false,
            formData: {},
            serviceTypeList: [],
            province: "",
            city: "",
            district: "",
            street: "",
            provinceList: [], //
            cityList: [],
            areaList: [],
            streetList: [],
            // srcList: [],
            polygons: [],
            communityList: [],
            gongdanData: [],
            titleList: [
                {
                    id: "1",
                    name: "基本信息",
                },
                {
                    id: "2",
                    name: "健康信息",
                },
                {
                    id: "3",
                    name: "工单信息",
                },
            ],
            total1: 0,
            healthCondition: [],
            controlAddContent: "1", // 控制新增弹框内部内容的切换
            checkDialogVisible: false,
            gongdanInfoForm: {},
            healthCondition: [],
            guardDays: 0,
        }
    },
    created() {
        this.getserviceType()
        this.baseUrl =
            baseURL + "/sqyl/controller/uploadController/info/uploadPhoto"
    },
    async mounted() {
        this.getData()
        await this.$nextTick(function () {
            setTimeout(() => {
                this.loadMap()
            }, 30)
        })
    },
    methods: {
        dialogVisibleClone() {
            this.$emit("setOrder")
            this.dialogVisible = false
        },
        changeIdx(id) {
            this.controlAddContent = id
        },

        diffTime(start, end) {
            start = start.replace(/-/g, "/")
            end = end.replace(/-/g, "/")
            let startDate = new Date(start)
            let endDate = new Date(end)
            let disparity = endDate.getTime() - startDate.getTime()
            let result = disparity / (1000 * 60)
            return result.toFixed(1)
        },
        getgongdanData() {
            request({
                url: "/sqyl/admin/serviceOrder/info/findList",
                method: "POST",
                data: {
                    elderlyId: this.orderId.id,
                    pageNo: this.gongdanQuery.pageNo,
                    pageSize: this.gongdanQuery.pageSize,
                },
            }).then((res) => {
                if (res.code === 200) {
                    if (res.content == "" || res.content == null) {
                        this.gongdanData = []
                        return
                    }
                    this.gongdanData = res.content.list
                    this.gongdanTotal = res.content.count
                } else {
                    this.$message({
                        message: "获取工单信息列表数据失败",
                        type: "error",
                    })
                }
            })
        },
        // 工单表格分页
        handleSizeChange(val) {
            this.gongdanQuery.pageSize = val
            this.getgongdanData()
        },
        handleCurrentChange(val) {
            this.gongdanQuery.pageNo = val
            this.getgongdanData()
        },
        getData() {
            request({
                url: "/sqyl/admin/elderly/info/getById",
                method: "POST",
                data: {
                    id: this.orderId.id,
                },
            }).then(async (res) => {
                if (res.code == 200) {
                    this.formData = res.content
                    this.guardDays = res.content.guardDays
                    this.formData.photo = res.content.photo
                    this.healthCondition =
                        this.formData.healthCondition.split(",")
                    let province = await this.getDistricts()
                    this.provinceList = province.districtList
                    this.formData.provinceId = String(this.formData.provinceId)
                    this.formData.cityId = String(this.formData.cityId)
                    this.formData.areaId = String(this.formData.areaId)
                    this.formData.streetId = String(this.formData.streetId)
                    if (!this.formData.provinceId) return
                    let city = await this.getDistricts(this.formData.provinceId)
                    this.cityList = city.districtList
                    if (!this.formData.cityId) return
                    let area = await this.getDistricts(this.formData.cityId)
                    this.areaList = area.districtList
                    if (!this.formData.areaId) return
                    let street = await this.getDistricts(this.formData.areaId)
                    this.streetList = street.districtList
                    if (!this.formData.streetId) return
                    let communityList = await this.getCommityList(
                        this.formData.streetId
                    )
                    this.communityList = communityList
                    this.formData.communityId = Number(
                        this.formData.communityId
                    )

                    setTimeout(async () => {
                        await this.$nextTick(() => {
                            this.potintMap()
                        })
                    }, 30)
                    this.$forceUpdate()
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
            })
            this.getgongdanData()
        },
        //获取服务对象数据
        getserviceType() {
            //页面初始化的时候以及查看编辑的时候展示全部
            let query = {
                pageNum: 1,
                pageSize: 999,
                dictType: "customer.type",
            }
            this.$http
                .request({
                    url: "/rbac/system/dict/data/list",
                    method: "get",
                    params: query,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.rows != null) {
                            this.serviceTypeList = res.rows
                        }
                    }
                })
        },
        // 查看单个工单信息
        checkGongdaninfo(row, title) {
            this.checkDialogVisible = true
            this.gongdanInfoForm = row
            row.serPhoto = row.serPhoto.split("#")
        },
        srcList(index, imgArr) {
            let arr = []
            let i = 0
            for (i; i < imgArr.length; i++) {
                arr.push(imgArr[i + index])
                if (i + index >= imgArr.length - 1) {
                    index = 0 - (i + 1)
                }
            }
            return arr
        },
        clearForm() {
            this.auditDialogVisible = false
            this.gongdanInfoForm = {}
        },
        loadMap() {
            //地图加载
            return new Promise((resolve, reject) => {
                this.myMap = new AMap.Map("container1", {
                    resizeEnable: true,
                    zoom: 8,
                })
                resolve()
            })
        },
        // 打点
        potintMap() {
            const self = this
            try {
                self.myMap.remove(self.marker)
            } catch (err) {}
            self.marker = new AMap.Marker({
                icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [
                    Number(self.formData.longitude),
                    Number(self.formData.latitude),
                ],
            })
            self.myMap.add(self.marker)
            self.myMap.setFitView()
        },
        // 社区地址列表
        getCommityList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                        method: "POST",
                        data: {
                            jiedaoId: val,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            resolve(res.content)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {})
        },
        // 地图
        getMap(input) {
            const self = this
            const autoOptions = {
                city: self.formData.quId,
                citylimit: true,
                input: input,
            }
            // alert(input)
            const auto = new AMap.Autocomplete(autoOptions)
            //构造地点查询类
            AMap.event.addListener(auto, "select", (e) => {
                self.formData.address = e.poi.name
                self.formData.longitude = e.poi.location.lng
                self.formData.latitude = e.poi.location.lat
                self.potintMap()
            })
        },
        //获取地址
        getDistricts(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {}

                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                    }
                })
            }).catch((err) => {})
        },
    },
}
</script>

<style lang="less" scoped>
.dialog_container {
    /deep/ .el-dialog__header {
        border-bottom: 1px solid #e5e5e5;
    }
}
.changeColor > div:first-child {
    background-color: #0000ff;
}

.changeColor > div:nth-child(2) {
    color: #0000ff;
}

.changeColor > div:last-child {
    background-color: #0000ff;
}
.name-per {
    width: 90%;
    display: flex;
    margin: 0 auto 20px;
}

.name-list {
    width: 50%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    text-align: center;
}

.name-list > div:first-child {
    width: 100%;
}

.name-title {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.name-title > div:first-child {
    width: 50%;
    height: 2px;
    background-color: #eeeeee;
}

.name-title > div:last-child {
    width: 50%;
    height: 2px;
    background-color: #eeeeee;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px dashed #c9c9c9;
}
.image-slot {
    .avatar-uploader-icon {
        width: 100px;
        height: 100px;
        line-height: 100px;
    }
}
.demo-image__preview {
    overflow: hidden;
    .el-image {
        width: 100px;
        margin-right: 10px;
        height: 100px;
        float: left;
        .demo-image__preview {
            width: 100px;
            height: 100px;
        }
    }
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.rightBox {
    margin-left: 30px;
    text-align: center;
    width: 100%;
    display: flex;
}

.uploadBtn {
    width: 170px;
    height: 50px;
    margin-left: 5px;
    background-color: #66b1ff;
    color: #fff;
    font-size: 18px;
    border-radius: 5px;
    line-height: 50px;
    margin-top: 20px;
}
.serviceInfoBox {
    display: flex;
    width: 100%;
    justify-content: flex-start;
}
.map_container1 {
    width: 89%;
    margin-left: 100px;
    margin-bottom: 20px;
}
.addressContent {
    flex: 1;

    .addressBox {
        display: flex;

        .addressItem {
            flex: 1;

            /deep/ .el-form-item__content {
                margin-left: 0px !important;
            }

            /deep/ .el-select {
                width: 100% !important;
            }
        }
    }

    /deep/ .el-form-item__content {
        margin-left: 0px !important;
    }
}
.bgs {
    width: 100%;
    height: 100%;
    margin-left: 10%;
}
.bgColor {
    width: 178px;
    height: 178px;
    background: url("../../assets/img/rlday.png");
    background-size: 100% 100%;
    position: relative;
    text-align: center;
    .days {
        position: absolute;
        top: 23px;
        color: #000;
        width: 100%;
        font-size: 24px;
    }
    .data {
        position: absolute;
        bottom: 21%;
        color: #ff6666;
        width: 100%;
        font-size: 36px;
        font-weight: bold;
    }
}
</style>
